// extracted by mini-css-extract-plugin
module.exports = {"base":"BrandMark-base-3v_nt","md":"BrandMark-md-3XwTk","lg":"BrandMark-lg-2ZfpK"};